import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getProfile } from "../services/user.service";
import { buildAlertsFromProfile, getDismissedAlertIds } from "../utils/healthAlerts";

export function useHealthAlertCount() {
  const location = useLocation();
  const [count, setCount] = useState(0);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const profile = await getProfile();
        if (cancelled) return;
        const dismissed = getDismissedAlertIds();
        setCount(buildAlertsFromProfile(profile, dismissed).length);
      } catch {
        if (!cancelled) setCount(0);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [location.pathname]);

  return count;
}
